const listeners = new Set();
const recent = new Map();

const DEDUPE_WINDOW = 3000;

let nextId = 0;

const emit = (tone, message, options = {}) => {
  if (!message) return null;

  // A failing API can reject several queries at once; without this the operator
  // gets the same sentence stacked four times.
  const signature = `${tone}:${message}`;
  const now = Date.now();
  const last = recent.get(signature);
  if (last && now - last < DEDUPE_WINDOW) return null;
  recent.set(signature, now);

  const toast = {
    id: (nextId += 1),
    tone,
    message,
    title: options.title || '',
    duration: options.duration ?? (tone === 'error' ? 8000 : 4500),
  };

  listeners.forEach((listener) => listener(toast));
  return toast.id;
};

export const notify = {
  success: (message, options) => emit('success', message, options),
  error: (message, options) => emit('error', message, options),
  info: (message, options) => emit('info', message, options),
};

export const subscribeToNotifications = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
